export const store = {
  token: '',
};
